
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import OurRules from "../../components/ourRules";
import InfoSection from "../../components/infoSection";
import Instagram from "../../components/instagram";
import RecommendedProducts from "../../components/recommendedProducts";
import {useUI} from "@components/ui";
import MarkFavorite from "@components/product/markFavorite";
import { useAddItem } from '@framework/cart'
import useTranslation from 'next-translate/useTranslation';
import Layout from "@components/common/Layout";
import {GetServerSideProps, GetStaticPropsContext} from "next";
import storevio from "@lib/api";

// @ts-ignore
 async function _getServerSideProps({locale}: GetServerSideProps) {

    const topNavLinks = await storevio.getMenu(locale!,'top')
    const bottomNavLinks = await storevio.getMenu(locale!,'bottom')
    const settings = await storevio.getSettings(locale!);

    return {
        props: {
            topNavLinks,
            bottomNavLinks,
            settings
        },
    }
}

export default function ZodpovednaVyroba({...props}) {

    return (
        <>
            <section className="about">
                <div className="about-image">
                    <img src="/images/about-image.jpg" alt="" />
                </div>
                <div className="about-content">
                    <h2>
                        Všechny výrobky TONAK splňují vysoké etické a ekologické požadavky s ohledem na domácí produkci
                    </h2>

                    <div className="about-content-sides">
                        <p>Firma TONAK a.s. je český výrobce klobouků a čepic se sídlem v Novém Jičíně a Strakonicích. Od roku 1799 je jedním z nejvýznamnějších evropských výrobců pokrývek hlav.<br /><br />
                        Tradiční značka Fezko Strakonice, proslavená výrobou fezů, pletených baretů a čepic se spojila s novojičínskou továrnou v roce 2001. Společně se řadí mezi největší světové kloboučnické firmy a 90 % své produkce vyváží do celého světa. V Novém Jičíně se vyrábějí například židovské klobouky pro Ameriku a Izrael, fezy pro muslimské země, plstěné klobouky pro Japonsko nebo černé buřinky pro indiánky v Peru a Bolívii. Šijí se tu také barety a brigadýrky pro armádu, policii, vězeňskou službu i pro hasiče. Ve Strakonicích se vyrábí populární zmijovky pro africký trh, módní, ale i armádní barety a další pletené pokrývky hlavy.<br /><br />
                        Zodpovědná ekologická výroba čepic, baretů a tradičních klobouků se soustředí na minimalizaci negativního dopadu na životní prostředí během celého procesu výroby.</p>
                    </div>

                    <div className="about-content-sides">
                        <div className="about-content-side">
                            <h3><img src="/images/cb-ethic-breeding.svg" alt="" /> Etický chov</h3>
                            <p>
                                Správný plstěný klobouk nejde vyrobit jinak než z králičí srsti. Není ovšem srst jako srst. Naši králíci pocházejí z certifikovaných českých malochovů, králík měl tedy během svého života důstojné podmínky, správnou výživu a výběh na louce. Díky tomu může být srst kvalitní. Na konci jeho života si pak jeho srst vezmeme, a tak se vše účelně zužitkuje.
                            </p>
                            <img src="/images/04.jpg" alt="" />
                                <h3><img src="/images/cb-mulenig-free.svg" alt="" /> Mullesing free vlna</h3>
                                <p>
                                    Vlnu nakupujeme pouze od ověřených dodavatelů, kteří neaplikují na ovcích mullesing a aktivně se tomuto tématu věnujeme. Mullesing-free vlna má výhodu, že ji lze produkovat bez krutosti vůči zvířatům a také se stává preferovanou volbou pro spotřebitele, kteří chtějí podporovat etické a udržitelné praktiky v oděvním průmyslu.

                                </p>
                                <img src="/images/02.jpg" alt="" />
                                    <h3><img src="/images/cb-czech-made.svg" alt="" /> Vyrobeno v České republice</h3>
                                    <p>
                                        Nejenže vstupní materiál nakupujeme v České republice, ale jejich zpracování až po finální výrobek probíhá u nás v Novém Jičíně a Strakonicích. Zachováváme kloboučnické a pletařské řemeslo a neustále ho rozvíjíme. I přes složité podmínky globalizace se nám podařilo udržet výrobní proces až po finální výrobek u nás v České republice.
                                    </p>
                        </div>
                        <div className="about-content-side">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/Ol4IthKrCfk"
                                    title="YouTube video player" frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen></iframe>
                                <h3 style={{marginTop: 20}}><img src="/images/cb-zero-waste.svg" alt="" /> Bezodpadová výroba</h3>
                                <p>
                                    Dovedete si představit výrobu produktu, kde není výrobní odpad? Zbytky použitých materiálů, odřezky, kartony, atd? U nás zpracujeme vše. Protože používáme výhradně přírodní materiály a výrobní proces je bez použití chemie, můžeme zbytkový materiál využít za účelem dalšího zpracování, konkrétně na výrobu vlastního bio hnojiva, známého pod názvem BIOFORCE. Jde nám totiž o planetu.

                                </p>
                                <img src="/images/01.jpg" alt="" />
                                    <h3><img src="/images/cb-hand-made.svg" alt="" /> Ruční výroba
                                    </h3>
                                    <p>
                                        Ruční práce je nenahraditelná u výroby čepic, baretů i klobouků. Obzvlášť, máte-li vysoké nároky na kvalitu pokrývky hlavy a její jedinečnost. Na výrobu jednoho klobouku je zapotřebí 150 výrobních operací a z toho 80 operací je ruční práce. Jedině tak docílíme tvaru, který drží po generace a může se pyšnit promyšlenými detaily. Stejně tak potisky, vzory či zdobení - za vším stojí šikovné ruce našich designérů. Pletařství a kloboučnictví je prostě řemeslo v pravém slova smyslu.

                                    </p>
                                    <img src="/images/03.jpg" alt="" />
                                        <h3><img src="/images/cb-chemical-free-cleaning.svg" alt="" /> Výroba bez chemie
                                        </h3>
                                        <p>
                                            Nejenže všechny klobouky a čepice jsou z přírodních materiálů, ale především jejich výroba nevyužívá chemické procesy. Můžete si tak být jisti tím, co nosíte na hlavě a nemít obavu z nepříjemných reakcí na pokožku. Pokrývky hlavy tak nezatěžují životní prostředí během výroby a jsou plně ekologicky recyklovatelné.

                                        </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="our-rules"><h2 className="title">Ochranné známky</h2>
                <p>TONAK a.s. využívá mimo jiné především tyto ochranné známky.</p>
                <ul className="our-rules-items">
                    <li><img src="/images/logo.svg" alt="" style={{width: 250}} /></li>
                    <li><img src="/images/fezko_black.png" alt="" /></li>
                </ul>
            </section>

            <section className="our-rules"><h2 className="title">Etický kodex</h2>
                <p><a href={"/pdf/eticky-kodex.pdf"} target={"_blank"} rel={"noreferrer"}>(etický kodex.pdf)</a></p>
            </section>

            <section className="our-rules"><h2 className="title">Politika jakosti</h2>
                <p>Vedení TONAK a.s., závod Strakonice s vědomím své zodpovědnosti za prosperitu společnosti
                    a vědomo si vlivu svých činností na kvalitu výrobků, dopadů na životní prostředí i na
                    hygienické podmínky při práci.<br /><br />
                    Politiku jakosti, bezpečnosti práce a ochrany životního prostředí <a href={"/pdf/politika_jakosti.pdf"} target={"_blank"} rel={"noreferrer"}>(politika_jakosti.pdf)</a><br /><br/>
                    Vedení TONAK a.s., závod Strakonice vyhlásilo Politiku jehel pro prevenci před kontaminací
                    výrobků kovovými částmi. <br /><br />
                Politika jehel <a href={"/pdf/politika_jehel.pdf"} target={"_blank"} rel={"noreferrer"}>(politika_jehel.pdf)</a></p>
            </section>

            <section className="our-rules"><h2 className="title">Certifikáty a ocenění</h2>
                <p>
                    <ul>
                        <li><a href={"/pdf/iso9001-bvc-cz.pdf"} target={"_blank"} rel={"noreferrer"}>ISO 9001 (iso9001-bvc-cz.pdf)</a></li>
                        <li><a href={"/pdf/iso14001-bvc-cz.pdf"} target={"_blank"} rel={"noreferrer"}>ISO 14001 (iso14001-bvc-cz.pdf)</a></li>
                        <li><a href={"/pdf/aqap-2110-cz.pdf"} target={"_blank"} rel={"noreferrer"}>AQAP 2110 (dodávky do NATO) (aqap-2110-czen.pdf)</a></li>
                        <li><a href={"/pdf/oeko-tex-standard-100-cz.pdf"} target={"_blank"} rel={"noreferrer"}>STANDARD 100 by OEKO-TEX® (výrobky neškodí lidskému zdraví) (oeko-tex-standard-
                            100-cz.pdf)</a></li>
                        <li><a href={"/pdf/ravena.pdf"} target={"_blank"} rel={"noreferrer"}>IES přezkoušení typu č. 1021-09-019 (ravena.pdf)</a></li>
                        <li><a href={"/pdf/woolmark.pdf"} target={"_blank"} rel={"noreferrer"}>Woolmark (woolmark.pdf)</a></li>
                        <li><a href={"/pdf/sotex-ginetex.pdf"} target={"_blank"} rel={"noreferrer"}>SOTEX GINETEX CZ (sotex-ginetex.pdf)</a></li>
                        <li><a href={"/pdf/ekokom.pdf"} target={"_blank"} rel={"noreferrer"}>Obaly (ekokom.pdf)</a></li>
                        <li><a href={"/pdf/Zelena_firma.pdf"} target={"_blank"} rel={"noreferrer"}>Zelená firma (Zelená_firma.pdf)</a></li>
                    </ul>
                </p>
            </section>

            <OurRules />
            <RecommendedProducts options={props.settings} />
            <InfoSection />
            <Instagram />
        </>
    );
}

ZodpovednaVyroba.Layout = Layout;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/page/zodpovedna-vyroba',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  